export const contactLocations = [
  {
    location: "Mantle Labs UK",
    address: "32 Padwell Road, Southampton SO14 6QZ",
    timezone: "Europe/London"
  },
  {
    location: "Mantle Labs Austria",
    address: "Grünentorgasse, 19/41090, Vienna",
    timezone: "Europe/Vienna"
  }
];
